window.documentCategoryFormatter = function(value, row) {
    let html = '';

    if (row.action_show) {
        html += '<a href="'+row.action_show+'">';
        html += value;
        html += '</a>';
    } else {
        html += value;
    }

    return html;
};
